class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    const overlay = this.querySelector('#CartDrawer-Overlay');
    if (overlay) overlay.addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  // The drawer is rendered whenever either the Desktop or the Mobile cart type asks for
  // it, so it must only take over when it is the type configured for this viewport.
  isActiveCartUI() {
    if (!window.cartDisplay) return true;
    return window.cartDisplay.getType() === 'drawer';
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    const syncAccessibility = () => {
      if (this.isActiveCartUI()) {
        cartLink.setAttribute('role', 'button');
        cartLink.setAttribute('aria-haspopup', 'dialog');
      } else {
        cartLink.removeAttribute('role');
        cartLink.removeAttribute('aria-haspopup');
      }
    };

    syncAccessibility();
    window.addEventListener('resize', syncAccessibility);

    // cartLink.addEventListener('click', (event) => {
    //   // On a viewport configured for the pop-up (or the cart page) let the link through.
    //   if (!this.isActiveCartUI()) return;

    //   event.preventDefault();
    //   let showDrawer = document.body.dataset.showDrawer !== 'false';
    //   if (!showDrawer) {
    //     window.location = window.routes.cart_url;
    //   } else {
    //     this.open(cartLink);
    //   }
    // });
    // cartLink.addEventListener('keydown', (event) => {
    //   if (!this.isActiveCartUI()) return;
    //   if (event.code.toUpperCase() === 'SPACE') {
    //     event.preventDefault();
    //     this.open(cartLink);
    //   }
    // });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');
    window.initializeFlickity();
    if (typeof window.saveCardsSlider === 'function') window.saveCardsSlider();
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    

    let showDrawer = document.body.dataset.showDrawer !== 'false';
    if (!showDrawer || !this.isActiveCartUI()) {
      // stay on page, don't redirect, don't open drawer
      return;
    } else {
      setTimeout(() => {
        const overlay = this.querySelector('#CartDrawer-Overlay');
        if (overlay) overlay.addEventListener('click', this.close.bind(this));
        this.open();
      });
    }

    window.saveCardsSlider();

  }

  /*
    The drawer's contents are only refreshed by add-to-cart requests made while the drawer
    is the cart UI configured for the current viewport. When the viewport crosses the
    breakpoint into a configuration that uses the drawer, pull a fresh copy so that it
    never opens with stale contents.
  */
  refreshContents() {
    return fetch(`${window.routes.cart_url}?section_id=cart-drawer`)
      .then((response) => response.text())
      .then((text) => {
        const section = document.getElementById('CartDrawer');
        if (!section) return;

        const document_ = new DOMParser().parseFromString(text, 'text/html');
        const parsedSection = document_.querySelector('#CartDrawer');
        if (!parsedSection) return;

        section.innerHTML = parsedSection.innerHTML;

        const parsedDrawer = document_.querySelector('cart-drawer');
        if (parsedDrawer) this.classList.toggle('is-empty', parsedDrawer.classList.contains('is-empty'));

        const overlay = this.querySelector('#CartDrawer-Overlay');
        if (overlay) overlay.addEventListener('click', this.close.bind(this));

        if (typeof window.saveCardsSlider === 'function') window.saveCardsSlider();
      })
      .catch((e) => console.error(e));
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);


class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    // Detect CART PAGE by a unique element or pathname
    const isCartPage =
      window.location.pathname.includes('/cart') ||
      !!document.getElementById('main-cart-items');

    if (isCartPage) {
      return [
        {
          id: 'CartDrawer',
          section: 'cart-drawer',
          selector: '.drawer__inner'
        },
        {
          id: 'cart-icon-bubble',
          section: 'cart-icon-bubble',
          selector: '.shopify-section'
        },
        {
          id: 'main-cart-items',
          section: document.getElementById('main-cart-items').dataset.id,
          selector: '.js-contents'
        },
        {
          id: 'cart-live-region-text',
          section: 'cart-live-region-text',
          selector: '.shopify-section'
        },
        {
          id: 'main-cart-footer',
          section: document.getElementById('main-cart-footer').dataset.id,
          selector: '.js-contents'
        },
        {
          id: 'main-cart-footer',
          section: document.getElementById('main-cart-footer').dataset.id,
          selector: '.Cart_Accordion'
        }
      ];
    } else {
      // Not cart page: bare minimum that affects the drawer
      return [
        {
          id: 'CartDrawer',
          section: 'cart-drawer',
          selector: '.drawer__inner'
        },
        {
          id: 'cart-icon-bubble',
          section: 'cart-icon-bubble',
          selector: '.shopify-section'
        }
      ];
    }
  }
}

// class CartDrawerItems extends CartItems {
//   getSectionsToRender() {
//     return [
//       {
//         id: 'CartDrawer',
//         section: 'cart-drawer',
//         selector: '.drawer__inner'
//       },
//       {
//         id: 'cart-icon-bubble',
//         section: 'cart-icon-bubble',
//         selector: '.shopify-section'
//       },
//       {
//         id: 'main-cart-items',
//         section: document.getElementById('main-cart-items').dataset.id,
//         selector: '.js-contents'
//       },
//       {
//         id: 'cart-icon-bubble',
//         section: 'cart-icon-bubble',
//         selector: '.shopify-section'
//       },
//       {
//         id: 'cart-live-region-text',
//         section: 'cart-live-region-text',
//         selector: '.shopify-section'
//       },
//       {
//         id: 'main-cart-footer',
//         section: document.getElementById('main-cart-footer').dataset.id,
//         selector: '.js-contents'
//       },
//       {
//         id: 'main-cart-footer',
//         section: document.getElementById('main-cart-footer').dataset.id,
//         selector: '.Cart_Accordion'
//       }
//     ];
//   }
// }

customElements.define('cart-drawer-items', CartDrawerItems);

window.saveCardsSlider = function () {

  let cardsEle = document.querySelector('.save-every-order__cards-slider');
  if (!cardsEle || typeof Flickity === 'undefined') return;

  var flkty = new Flickity(cardsEle, {
    cellAlign: 'left',
    wrapAround: false,
    contain: true,
    pageDots: false,
    // One card per swipe on every device. freeScroll let a single drag coast past
    // several cards, which is the "grab swipe" behaviour we don't want.
    freeScroll: false,
    groupCells: 1,
    // A deliberate horizontal swipe clears this easily; thumb wobble during a
    // vertical scroll of the drawer does not (see enableCarouselSwipe).
    dragThreshold: 10,
    prevNextButtons: true,
    adaptiveHeight: false,
    arrowShape: {
      x0: 15,
      x1: 60, y1: 50,
      x2: 70, y2: 40,
      x3: 35
    }
  });

  // Flickity's constructor returns the existing instance when the element is already
  // enhanced and only re-applies options -- it never re-measures. This function re-runs
  // on drawer open, on resize and after cart re-renders, so resize explicitly to stop
  // those re-runs leaving stale cell geometry behind.
  //
  // Only when the carousel is actually visible: cart-display-settings hides <cart-drawer>
  // with display:none on whichever viewport is not configured for the drawer, and Flickity
  // measures a display:none element as zero, which collapses the viewport to 0px.
  // offsetWidth (rather than visibility) is the right test: a closed drawer is only
  // visibility:hidden + translated off-canvas, so it still has real geometry to measure.
  if (flkty && typeof flkty.resize === 'function' && cardsEle.offsetWidth > 0) {
    flkty.resize();
  }

  if (typeof window.enableCarouselSwipe === 'function') {
    window.enableCarouselSwipe(flkty, cardsEle);
  }

}



document.addEventListener('DOMContentLoaded', window.saveCardsSlider);
window.addEventListener('resize', window.saveCardsSlider);